import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import { UserPost } from '../providers/user-posts';
import { UserComment } from '../providers/comment';
import { UserFeedback } from '../providers/user-feedback';
import { ToastController } from 'ionic-angular';
//import { UserData } from '../providers/user-data';

export interface ItemsResponse {
  results: string[];
}



@Injectable()
export class ApiService {

  results: string[];
  private url = "http://localhost:8080";
  //private url = "https://jz457w6dui.execute-api.us-west-2.amazonaws.com/LRxAloha?chemical_name=BUTANE"
  //private url = "http://google.com"
  
  constructor(private http: HttpClient,private toastCtrl: ToastController) {}

  //Put item example
  /*
  var params = {
    Item: {
     "AlbumTitle": {
       S: "Somewhat Famous"
      }, 
     "Artist": {
       S: "No One You Know"
      }, 
     "SongTitle": {
       S: "Call Me Today"
      }
    }, 
    ReturnConsumedCapacity: "TOTAL", 
    TableName: "Music"
   };
   */
  postPic(postData:UserPost, CallBack){
    postData.postTimeStamp = new Date().valueOf();
    var params = {
      Item: postData, 
      //TableName: "PicLadderPosts"
     };
    //this.http.post('https://2s4dhb8rk6.execute-api.us-west-2.amazonaws.com/picladder', postData)
    this.http.post('https://2s4dhb8rk6.execute-api.us-west-2.amazonaws.com/picladder', params)
    .subscribe(
      data => {
      // Read the result field from the JSON response.
      this.results = data['Message'];
      //myCallBack();
      CallBack(data);
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          // A client-side or network error occurred. Handle it accordingly.
          console.log('An error occurred:', err.error.message);
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          console.log(`Backend returned code ${err.status}, body was: ${err.error}`);
        }
      }
    );
  }

  postComment(commentData:UserComment, CallBack){
    //var params = {
    //  Item: commentData, 
    // };
     //var test = {
     //  "Comment": "Test Post CommentDB",
     //  "PostId" : "TestJeffLate"
     //};
     //let hdrs = new HttpHeaders().set('Content-Type','application/json')
    this.http.post('https://wb2vc1m4u1.execute-api.us-west-2.amazonaws.com/Prod/PostComment', commentData)
    //this.http.post('https://wb2vc1m4u1.execute-api.us-west-2.amazonaws.com/Stage/PostComment', test)
    .subscribe(
      data => {
      // Read the result field from the JSON response.
      //this.results = data['Message'];
      CallBack(data);
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          // A client-side or network error occurred. Handle it accordingly.
          console.log('An error occurred:', err.error.message);
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          console.log(`Backend returned code ${err.status}, body was: ${err.error}`);
        }
      }
    );
  }

  postFeedback(feedbackData:UserFeedback, CallBack){
    this.http.post('https://12actaguxd.execute-api.us-west-2.amazonaws.com/Prod', feedbackData)
    //this.http.post('https://wb2vc1m4u1.execute-api.us-west-2.amazonaws.com/Stage/PostComment', test)
    .subscribe(
      data => {
      // Read the result field from the JSON response.
      //this.results = data['Message'];
      CallBack(data);
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          // A client-side or network error occurred. Handle it accordingly.
          console.log('An error occurred:', err.error.message);
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          console.log(`Backend returned code ${err.status}, body was: ${err.error}`);
        }
      }
    );
  }

  /*turnOnServer(){
    let url = "https://47jhr6ur6k.execute-api.us-west-2.amazonaws.com/prod";
    let start_stop = "1";
    let queryParams = new HttpParams().set('start_stop', start_stop).set("instanceId",this.instanceId);
    //this.http.get(url,{params:queryParams,
    //    headers: new HttpHeaders().set('Authorization', this.getAccessHeader())})
    this.http.get(url,{params:queryParams})
    .subscribe(
      data => {
      // Read the result field from the JSON response.
      this.results = data['StartingInstances'];
      let toast = this.toastCtrl.create({
        message: 'Starting Service!',
        duration: 3000,
        position: 'top'
      });
    
      toast.onDidDismiss(() => {
        console.log('Dismissed toast');
      });    
      toast.present();
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          // A client-side or network error occurred. Handle it accordingly.
          console.log('An error occurred:', err.error.message);
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          console.log(`Backend returned code ${err.status}, body was: ${err.error}`);
        }
      }
    );
  }
*/


  getUserData(CallBack){
    let url = "https://izgdm18clj.execute-api.us-west-2.amazonaws.com/Prod/GetUserData";
    //let queryParams = new HttpParams().set('sub', sub);
    //this.http.get(url,{params:queryParams})
    this.http.get(url)
    .subscribe(
      data => {
      // Read the result field from the JSON response.
      //this.results = data['posts'];
      CallBack(data['Items'][0]);
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          // A client-side or network error occurred. Handle it accordingly.
          console.log('An error occurred:', err.error.message);
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          console.log(`Backend returned code ${err.status}, body was: ${err.error}`);
        }
      }
    );
  }

  updateUserData(avatarKey:string, CallBack){
    var params = {
       "avatarKey":avatarKey
     };
    this.http.post('https://vfcb5p4yaj.execute-api.us-west-2.amazonaws.com/Prod/', params)
    .subscribe(
      data => {
      // Read the result field from the JSON response.
      //this.results = data['Message'];
      CallBack(data);
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          // A client-side or network error occurred. Handle it accordingly.
          console.log('An error occurred:', err.error.message);
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          console.log(`Backend returned code ${err.status}, body was: ${err.error}`);
        }
      }
    );
  }

  getComments(postId:string, lastKey:any="",CallBack){
    let url = "https://ld6u2q3x3m.execute-api.us-west-2.amazonaws.com/Prod/";
    let params = {
                    "PostId":postId,
                    "lastkey": lastKey
    }
    this.http.post(url, params)
    .subscribe(
      data => {
      // Read the result field from the JSON response.
      //this.results = data['posts'];
      //CallBack(data['Items']);
      CallBack(data);
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          // A client-side or network error occurred. Handle it accordingly.
          console.log('An error occurred:', err.error.message);
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          console.log(`Backend returned code ${err.status}, body was: ${err.error}`);
        }
      }
    );
  }

  getCommentReplys(commentId:string, lastKey:any="",CallBack){
    let url = "";//"https://or6vfx848a.execute-api.us-west-2.amazonaws.com/Prod/GetLadderPosts";
    let params = {
                    "ReplyToId":commentId,
                    "lastkey": lastKey
    }
    this.http.post(url, params)
    .subscribe(
      data => {
      // Read the result field from the JSON response.
      //this.results = data['posts'];
      //CallBack(data['Items']);
      CallBack(data);
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          // A client-side or network error occurred. Handle it accordingly.
          console.log('An error occurred:', err.error.message);
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          console.log(`Backend returned code ${err.status}, body was: ${err.error}`);
        }
      }
    );
  }

  getCategories(CallBack){
    let url = "https://n7osumjaf4.execute-api.us-west-2.amazonaws.com/Prod/GetCategories";
    //let queryParams = new HttpParams().set('sub', sub);
    //this.http.get(url,{params:queryParams})
    this.http.get(url)
    .subscribe(
      data => {
      // Read the result field from the JSON response.
      //this.results = data['posts'];
      CallBack(data['Items']);
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          // A client-side or network error occurred. Handle it accordingly.
          console.log('An error occurred:', err.error.message);
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          console.log(`Backend returned code ${err.status}, body was: ${err.error}`);
        }
      }
    );
  } 

  getPics(category:string, lastKey:any=null,CallBack){
    //let url = "https://or6vfx848a.execute-api.us-west-2.amazonaws.com/Prod/GetLadderPosts";
    let url = "https://or6vfx848a.execute-api.us-west-2.amazonaws.com/Prod/GetLadderPosts";
    //let queryParams = new HttpParams().set('category', category).set("lastDate",lastDate);
    //this.http.get(url,{params:queryParams,
    //    headers: new HttpHeaders().set('Authorization', this.getAccessHeader())})
    //this.http.get(url,{params:queryParams})
    let params = {
                    "category":category,
                    "lastkey": ""
    }
    if (lastKey != null){
      params.lastkey = lastKey; 
    }   
    this.http.post(url, params)
    .subscribe(
      data => {
      // Read the result field from the JSON response.
      //this.results = data['posts'];
      //CallBack(data['Items']);
      //data['Items'].sort((leftSide,rightSide):number=> {
      //  if(leftSide.postTimeStamp < rightSide.postTimeStamp) return -1;
      //  if(leftSide.postTimeStamp > rightSide.postTimeStamp) return 1;
      //  return 0;
      //});
      CallBack(data);
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          // A client-side or network error occurred. Handle it accordingly.
          console.log('An error occurred:', err.error.message);
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          console.log(`Backend returned code ${err.status}, body was: ${err.error}`);
        }
      }
    );
  }

  getUserPosts(userName:string, lastKey:any=null,CallBack){
    let url = "https://zrsf258lql.execute-api.us-west-2.amazonaws.com/Prod";
    let params = {
                    "username":userName,
                    "lastkey": ""
    }
    if (lastKey != null){
      params.lastkey = lastKey; 
    }   
    this.http.post(url, params)
    .subscribe(
      data => {
      CallBack(data);
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          // A client-side or network error occurred. Handle it accordingly.
          console.log('An error occurred:', err.error.message);
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          console.log(`Backend returned code ${err.status}, body was: ${err.error}`);
        }
      }
    );
  }


  //https://6dal31244h.execute-api.us-west-2.amazonaws.com/Prod
  checkVoteGenerator(CallBack){
    let params = {
    }
    this.http.post('https://6dal31244h.execute-api.us-west-2.amazonaws.com/Prod',params)
    //this.http.post('https://wb2vc1m4u1.execute-api.us-west-2.amazonaws.com/Stage/PostComment', test)
    .subscribe(
      data => {
      // Read the result field from the JSON response.
      //this.results = data['Message'];
      let test = "t";
      CallBack(data);
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          // A client-side or network error occurred. Handle it accordingly.
          console.log('An error occurred:', err.error.message);
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          console.log(`Backend returned code ${err.status}, body was: ${err.error}`);
        }
      }
    );
  }

  EmptyVoteGenerator(CallBack){
    let params = {
    }
    this.http.post('https://b247o0g2li.execute-api.us-west-2.amazonaws.com/Prod',params)
    //this.http.post('https://wb2vc1m4u1.execute-api.us-west-2.amazonaws.com/Stage/PostComment', test)
    .subscribe(
      data => {
      // Read the result field from the JSON response.
      //this.results = data['Message'];
      let test = "t";
      CallBack(data);
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          // A client-side or network error occurred. Handle it accordingly.
          console.log('An error occurred:', err.error.message);
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          console.log(`Backend returned code ${err.status}, body was: ${err.error}`);
        }
      }
    );
  }

  UpdateAvatarKey(CallBack, avatarKey:string ){
    //Deprecated use update user
    /*
    let params = {
      "avatarKey": avatarKey
    }
    this.http.post('https://b247o0g2li.execute-api.us-west-2.amazonaws.com/Prod/UpdateAvatar',params)
    //this.http.post('https://wb2vc1m4u1.execute-api.us-west-2.amazonaws.com/Stage/PostComment', test)
    .subscribe(
      data => {
      // Read the result field from the JSON response.
      //this.results = data['Message'];
      let test = "t";
      CallBack(data);
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          // A client-side or network error occurred. Handle it accordingly.
          console.log('An error occurred:', err.error.message);
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          console.log(`Backend returned code ${err.status}, body was: ${err.error}`);
        }
      }
    );*/
  }

  voteForPic(post:UserPost, CallBack){
    //TODO add votes api
    //alert("Implement vote API!")
    var params = {
      UserPostId: post.UserPostId, 
      };
    this.http.post('https://d1lcp8pg2i.execute-api.us-west-2.amazonaws.com/Prod/VoteForPost', params)
    //this.http.post('https://wb2vc1m4u1.execute-api.us-west-2.amazonaws.com/Stage/PostComment', test)
    .subscribe(
      data => {
      // Read the result field from the JSON response.
      //this.results = data['Message'];
      CallBack(post);
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          // A client-side or network error occurred. Handle it accordingly.
          console.log('An error occurred:', err.error.message);
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          console.log(`Backend returned code ${err.status}, body was: ${err.error}`);
        }
      }
    );
  }

  deletePic(post:UserPost, CallBack){
    //alert("Implement vote API!")
    var params = {
      UserPostId: post.UserPostId, 
      };
    this.http.post('https://zz4p5s5xd2.execute-api.us-west-2.amazonaws.com/Prod/', params)
    //this.http.post('https://wb2vc1m4u1.execute-api.us-west-2.amazonaws.com/Stage/PostComment', test)
    .subscribe(
      data => {
      // Read the result field from the JSON response.
      //this.results = data['Message'];
      CallBack(post);
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          // A client-side or network error occurred. Handle it accordingly.
          console.log('An error occurred:', err.error.message);
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          console.log(`Backend returned code ${err.status}, body was: ${err.error}`);
        }
      }
    );
  }

  showLeaderBoard(level:number,sort:string,lastKey:any=null, CallBack){
    let url = "https://piu72vsg3c.execute-api.us-west-2.amazonaws.com/Prod/";

    let params = {
                    "level":level,
                    "sort":sort,
                    "lastkey": ""
    }
    if (lastKey != null){
      params.lastkey = lastKey; 
    }   
    this.http.post(url, params)
    .subscribe(
      data => {
      CallBack(data);
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          // A client-side or network error occurred. Handle it accordingly.
          console.log('An error occurred:', err.error.message);
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          console.log(`Backend returned code ${err.status}, body was: ${err.error}`);
        }
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/api-service/api-service.ts